import { styled } from "../../Theme";

export const FooterContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  background-color: white;
  height: 2em;
  width: 100%;
  /* position: absolute;
  bottom: 0; */
  padding-top: 1em;
`;

export const FooterLink = styled.a`
  margin-top: auto;
  margin-bottom: auto;
  color: #8c8c8c;
  width:50%;
  text-align:center;
`;

export const FooterItemContent = styled.button`
  margin-top: auto;
  margin-bottom: auto;
  color: #8c8c8c;
  text-decoration: underline;
  background: none;
  border: none;
  font: inherit;
  cursor: pointer;
  width:50%;
`;

export const ContainerInModal = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
